import type { ReactNode } from 'react';

import PlaygroundWalkthroughRail from './PlaygroundWalkthroughRail';
import usePlaygroundDemoChromeVisible from './usePlaygroundDemoChromeVisible';

/**
 * Puts the QA Playground "Demo Walkthrough" rail (#9141) to the left of an app shell's content
 * while Playground is ON. Outside Playground it returns the content untouched (no wrapper), so
 * normal sessions keep exactly today's layout.
 *
 * `scrollsDocument` is the root.tsx default shell, where the document scrolls: the rail sticks
 * under the sticky header group, whose height root.tsx publishes as `--app-chrome-height`.
 * In the other two shells the content pane scrolls inside a fixed-height column, so the rail
 * simply fills the row's height and scrolls on its own.
 */
const PlaygroundRailLayout = ({
  children,
  scrollsDocument = false
}: {
  children: ReactNode;
  scrollsDocument?: boolean;
}) => {
  if (!usePlaygroundDemoChromeVisible()) {
    return <>{children}</>;
  }

  if (scrollsDocument) {
    return (
      <div className="flex items-start">
        <PlaygroundWalkthroughRail className="sticky top-[var(--app-chrome-height,0px)] h-[calc(100dvh-var(--app-chrome-height,0px))]" />
        <div className="min-w-0 flex-1">{children}</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1">
      <PlaygroundWalkthroughRail />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">{children}</div>
    </div>
  );
};

export default PlaygroundRailLayout;
